import { Typography, Skeleton, Tooltip, IconButton } from "@mui/material"

import InfoIcon from '@mui/icons-material/Info';
import { Box } from "@mui/system";

const TAX_EXCLUSIVE_MESSAGE = "Price excludes tax. Applicable taxes are calculated at checkout."

const TaxExclusiveInfo = ({ color = "rgb(249, 245, 238)", compact = false }) => {
  const size = compact ? "18px" : "20px"

  return <Tooltip arrow title={TAX_EXCLUSIVE_MESSAGE}>
    <IconButton
      aria-label="Price excludes tax"
      size="small"
      sx={{ color, p: 0, width: size, height: size }}
    >
      <InfoIcon sx={{ width: size, height: size }} />
    </IconButton>
  </Tooltip>
}

const toEuroString = (val) => {
  return `€${(val / 100).toFixed(2)}`
}

const PriceComponent = ({ product }) => {
  return (
    <Typography sx={{ display: "flex", mt: 2, fontWeight: "bold", fontSize: { xs: "30px", md: "40px" }, justifyContent: "center", alignItems: "center", gap: 2 }}>

      {product?.metadata?.original_price && <Typography textAlign="center" sx={{ fontWeight: 300, fontSize: { xs: "20px", md: "30px" }, color: "#dddddd", textDecoration: "line-through" }}>
        {toEuroString(product?.metadata?.original_price)}
      </Typography>}

      {product && toEuroString(product?.default_price?.unit_amount)}
      {product?.default_price?.unit_amount === undefined && <Skeleton variant="text" width={210} />}
      <TaxExclusiveInfo />
    </Typography >
  )
}

const PriceContent = ({ name, product }) => {
  return <Box sx={{
    p: { xs: 0, md: 2 },
    display: "flex",
    flexDirection: "column",
    columnGap: 2,
    color: "#fff",
    alignItems: "center",
    justifyContent: "left",
    textAlign: "left"
  }}>
    <Typography variant="caption">
      {name}
    </Typography>
    <Box sx={{ display: "flex", flexDirection: "row", columnGap: 1, alignItems: "center" }}>

      {product?.metadata?.original_price && <Typography textAlign="center" sx={{ fontWeight: 300, color: "#dddddd", textDecoration: "line-through" }}>
        {toEuroString(product?.metadata?.original_price)}
      </Typography>}
      <Typography sx={{ fontWeight: "bold", textAlign: "left", width: "100%" }}>
        {product && toEuroString(product?.default_price?.unit_amount)}
        {product?.default_price?.unit_amount === undefined && <Skeleton variant="text" width={100} />}
      </Typography>
      <TaxExclusiveInfo compact />

    </Box>
  </Box>
}

export { PriceContent, TaxExclusiveInfo };
export default PriceComponent
